import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo, } from 'react';
import { libsUiDataNames } from '@zurich/test/testdatanames';
import { Card } from '../Card';
import { CardEditEntity } from '../CardEditEntity';
import { IconButton } from '../IconButton';
import { Switch } from '../Switch';
export const CardEditable = forwardRef(function CardEditableComponent({ dataName, open, children, onOpen, onToggle, onDelete, onEdit, disabled, avatar = null, editable, deletable = true, coverComponent, error, helperText, customIcon, switchDataName, useSwitch = false, ...props }, ref) {
    const handleOpen = () => {
        if (!open && !disabled)
            onOpen && onOpen();
    };
    const handleDelete = (ev) => {
        ev.stopPropagation(); // avoid calling handleOpen
        onDelete && onDelete();
    };
    const variant = disabled
        ? 'disable'
        : open || editable
            ? 'standard'
            : 'add';
    /** TODO: evaluete if onOpen/onDelete are necessary with onToggle */
    // FIXME: simplify condition
    // action prop may only return ReactNode
    const action = useMemo(() => {
        if (useSwitch) {
            return (_jsx(Switch, { "data-name": switchDataName ?? libsUiDataNames.cardEditable.switch, size: "small", onClick: onToggle, disabled: disabled, checked: open }));
        }
        if (!disabled && open) {
            return deletable ? (_jsx(IconButton, { "data-name": libsUiDataNames.cardEditable.buttonDelete, onClick: handleDelete, color: "error", variant: "bin", size: "small" })) : customIcon?.length ? (_jsx(IconButton, { "data-name": libsUiDataNames.cardEditable.butonCustomDelete, onClick: handleDelete, color: "default", variant: customIcon, size: "small" })) : null;
        }
        if (disabled) {
            return null;
        }
        if (editable) {
            return (_jsxs(_Fragment, { children: [_jsx(IconButton, { "data-name": libsUiDataNames.cardEditable.buttonEdit, onClick: onEdit, variant: "pencil", size: "small" }), deletable ? (_jsx(IconButton, { "data-name": libsUiDataNames.cardEditable.buttonDelete, variant: "bin", color: "error", onClick: handleDelete, size: "small" })) : undefined] }));
        }
        if (deletable) {
            return (_jsx(IconButton, { "data-name": libsUiDataNames.cardEditable.buttonDelete, variant: "bin", color: "error", onClick: handleDelete, size: "small" }));
        }
        return (_jsx(IconButton, { "data-name": libsUiDataNames.cardEditable.buttonAdd, disabled: disabled, onClick: onEdit, variant: "plus", size: "small" }));
    }, [
        customIcon,
        deletable,
        disabled,
        editable,
        handleDelete,
        onEdit,
        onToggle,
        open,
        switchDataName,
        useSwitch,
    ]);
    return (_jsxs(Card, { error: error, helperText: helperText, ref: ref, dataName: dataName ?? libsUiDataNames.cardEditable.dataName, children: [_jsx(CardEditEntity, { open: open, editable: editable, variant: variant, avatar: avatar, action: action, onClick: handleOpen, ...props }), _jsx(_Fragment, { children: open ? children : coverComponent })] }));
});
